import { render, staticRenderFns } from "./EventDates.vue?vue&type=template&id=1687f308&scoped=true"
import script from "./EventDates.vue?vue&type=script&lang=js"
export * from "./EventDates.vue?vue&type=script&lang=js"
import style0 from "./EventDates.vue?vue&type=style&index=0&id=1687f308&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1687f308",
  null
  
)

export default component.exports